export default "__VITE_ASSET__BT2t3Mge__"